export default "__VITE_ASSET__CggYRNyL__"